import { useState, useEffect } from "react";
import { Product } from "../../types/Product";
import { HttpProduct } from "../../http";

export const useHomeProducts = () => {
    const [featuredProducts, setFeaturedProducts] = useState<Product[]>([]);
    const [latestProducts, setLatestProducts] = useState<Product[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const fetchProducts = () => {
        try {
            setLoading(true);
            setError(null);
            Promise.all([HttpProduct.getLatest(), HttpProduct.getFeatured()]).then(
                ([latestProductsData, featuredProductsData]) => {
                    setLatestProducts(latestProductsData);
                    setFeaturedProducts(featuredProductsData);
                },
            );
        } catch (err) {
            console.error("Error fetching products:", err);
            setError("Error al cargar los productos");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    return {
        showcaseProducts: featuredProducts,
        novedadesProducts: latestProducts.slice(0, 5),
        loading,
        error,
    };
};
